import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FcCollaboration,
  FcConferenceCall,
  FcDownRight,
  FcGoogle,
  FcHome,
  FcIdea,
  FcManager,
  FcMenu,
  FcPhone,
  FcRules,
  FcSettings,
  FcSupport,
  FcUpRight,
} from "react-icons/fc";
import {
  GlobalData,
  Companylogo,
  Sitelogo,
} from "../../assets/data/GlodalData";
import { IoMdLogOut } from "react-icons/io";
import { useAuth } from "../../hooks/AuthContext";
const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const { user, loading, logout } = useAuth();

  const [openIndex, setOpenIndex] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const [isProfileSidebarOpen, setIsProfileSidebarOpen] = useState(false);
  const [isReferSidebarOpen, setIsReferSidebarOpen] = useState(false);
  const [isQuickSelectSidebarOpen, setIsQuickSelectSidebar] = useState(false);

  const toggleProfileSidebar = () => {
    setIsProfileSidebarOpen(!isProfileSidebarOpen);
    setIsReferSidebarOpen(false);
    setIsQuickSelectSidebar(false);
  };

  const toggleReferSidebar = () => {
    setIsReferSidebarOpen(!isReferSidebarOpen);
    setIsProfileSidebarOpen(false);
    setIsQuickSelectSidebar(false);
  };

  const closeAllSidebars = () => {
    setIsProfileSidebarOpen(false);
    setIsReferSidebarOpen(false);
    setIsQuickSelectSidebar(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userData");
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const showNavbar = location.pathname !== "/";

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const navSections = [
    {
      title: "",
      links: [
        {
          name: "Dashboard",
          description: "Welcome to your Smart Business Manager 😊.",
          path: "/auth/dashboard",
          icon: <FcHome className="text-lg" />,
        },
      ].filter(Boolean),
    },
    {
      title: "",
      links: [
        {
          name: "Google Analytics",
          description: "Googel Analytics",
          path: "/auth/google-analytics",
          icon: <FcGoogle className="text-lg" />,
        },
        {
          name: "Contactus Form",
          description: "Frontend contact form",
          path: "/auth/contactus",
          icon: <FcRules className="text-lg" />,
        },
        {
          name: "Leads",
          description: "Frontend contact form",
          path: "/auth/leads",
          icon: <FcConferenceCall className="text-lg" />,
        },
      ].filter(Boolean),
    },

    {
      title: "System",
      links: [
        {
          name: "Settings",
          description: "Many Features coming soon.",
          path: "/auth/settings",
          icon: <FcSettings className="text-lg" />,
        },
        {
          name: "My Account",
          description: "Billing & Renewal details.",
          path: "/auth/my-account",
          icon: <FcManager className="text-lg" />,
        },
      ].filter(Boolean),
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarRef]);

  const NavLink = ({ link, onClick, isDropdown = false }) => (
    <Link
      to={link.path}
      className={`flex items-center p-2 rounded-lg transition-all duration-200 group ${
        location.pathname === link.path
          ? "bg-black text-white shadow-lg"
          : "text-gray-700 hover:bg-gray-100 hover:text-black"
      } ${isDropdown ? "pl-8 text-sm" : ""}`}
      onClick={onClick}
    >
      <div className="mr-3">{link.icon}</div>
      <div className="flex-col flex leading-tight">
        <span className="font-medium text-sm">{link.name}</span>
        <span className="text-[10px]">{link.description}</span>
      </div>
    </Link>
  );

  const NavItemWithDropdown = ({ link, index }) => (
    <div className="mb-1">
      <button
        onClick={() => toggleDropdown(index)}
        className={`flex items-center justify-between w-full p-2 rounded-lg transition-all duration-200 group ${
          location.pathname === link.path ||
          (link.dropdown &&
            link.dropdown.some((item) => location.pathname === item.path))
            ? "bg-black text-white shadow-lg"
            : "text-gray-700 hover:bg-gray-100 hover:text-black"
        }`}
      >
        <div className="flex items-center">
          <div className="mr-3">{link.icon}</div>
          <div className="flex-col flex text-left leading-tight">
            <span className="font-medium text-sm">{link.name}</span>
            <span className="text-[10px]">{link.description}</span>
          </div>
        </div>
        {openDropdown === index ? (
          <FcUpRight className="text-sm" />
        ) : (
          <FcDownRight className="text-sm" />
        )}
      </button>

      {openDropdown === index && link.dropdown && (
        <div className="mt-1 ml-3 border-l-2 border-gray-200 pl-2 space-y-1">
          {link.dropdown.map((dropdownLink, dropdownIndex) => (
            <NavLink
              key={dropdownIndex}
              link={dropdownLink}
              onClick={() => {
                if (window.innerWidth < 768) {
                  closeSidebar();
                }
                setOpenDropdown(null);
              }}
              isDropdown={true}
            />
          ))}
        </div>
      )}
    </div>
  );

  if (!showNavbar) return null;

  return (
    <>
      {/* Main Sidebar */}
      <div
        ref={sidebarRef}
        className={`fixed top-0 z-50 left-0 pt-14 h-full bg-white border-r border-gray-200 transition-all duration-300 ease-in-out 
    md:translate-x-0 md:w-64
    ${
      isSidebarOpen
        ? "translate-x-0 w-64"
        : "-translate-x-full w-0 md:translate-x-0 md:w-64"
    }
  `}
      >
        {/* Scrollable Section - Always show on desktop, conditionally on mobile */}
        <div
          className={`flex flex-col overflow-y-auto h-[calc(100vh-120px)] custom-scrollbar px-3 py-4 ${
            isSidebarOpen ? "block" : "hidden md:block"
          }`}
        >
          {navSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="mb-4">
              {section.title && (
                <div className="text-xs font-semibold text-gray-500 uppercase px-3 py-2 tracking-wider">
                  {section.title}
                </div>
              )}
              <div className="space-y-1">
                {section.links.map((link, linkIndex) =>
                  link.dropdown ? (
                    <NavItemWithDropdown
                      key={link.path}
                      link={link}
                      index={`${sectionIndex}-${linkIndex}`}
                    />
                  ) : (
                    <NavLink
                      key={link.path}
                      link={link}
                      onClick={() => {
                        if (window.innerWidth < 768) {
                          closeSidebar();
                        }
                      }}
                    />
                  )
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Fixed Bottom Section - Always show on desktop, conditionally on mobile */}
        <div
          className={`absolute bottom-0 left-0 right-0 border-t border-gray-200 bg-white ${
            isSidebarOpen ? "block" : "hidden md:block"
          }`}
        >
          <button
            onClick={logout}
            className="flex items-center justify-center w-full p-2 text-gray-700 hover:bg-gray-100 hover:text-black rounded-lg transition-all duration-200 group"
          >
            {" "}
            <span className="font-medium text-sm">Logout</span>
            <IoMdLogOut className="text-xl ml-3" />
          </button>
        </div>
      </div>

      {/* Top Navigation Bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-black shadow-lg h-14">
        <div className="flex items-center justify-between h-full px-4">
          {/* Left Section */}
          <div className="flex items-center space-x-2">
            {/* Mobile Menu Button */}
            <button
              onClick={toggleSidebar}
              className="text-white hover:bg-gray-800 rounded-lg transition duration-200 md:hidden"
            >
              {isSidebarOpen ? <div>X</div> : <FcMenu className="text-xl" />}
            </button>

            {/* Logo */}
            <Link to="/auth/dashboard" className="flex items-center">
              <div className="h-8 w-8 rounded-full bg-white flex items-center justify-center font-bold text-black">
                <img
                  src={Companylogo}
                  alt="Company Logo"
                  className="w-full h-full object-cover"
                />
              </div>
            </Link>
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-1">
            <div>
              <div className="text-xs sm:text-sm font-semibold text-white">
                {GlobalData.company.companyName}
              </div>
            </div>{" "}
            <div className="h-4 w-px bg-gray-600 mx-1"></div>
            {/* Refer & Earn */}
            <button
              onClick={toggleReferSidebar}
              className="p-2 text-white hover:text-white hover:bg-gray-800 rounded-lg transition duration-200"
              title="Refer & Earn"
            >
              <FcCollaboration className="text-xl" />
            </button>
            {/* Profile */}
            <button
              onClick={toggleProfileSidebar}
              className="flex items-center space-x-2 p-1 hover:bg-gray-800 rounded-lg transition duration-200 ml-1"
            >
              <div className="w-8 h-8 rounded-full bg-white overflow-hidden border-2 border-gray-300 shadow-sm">
                {Companylogo ? (
                  <img
                    src={Sitelogo}
                    alt="Company Logo"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-600 flex items-center justify-center text-white text-xs font-bold">
                    {GlobalData.company.companyName?.charAt(0) || "C"}
                  </div>
                )}
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div
        className={`
        transition-all duration-300
        ${isSidebarOpen ? "ml-64" : "ml-0"}
        md:ml-64
      `}
      >
        {/* Your main content goes here */}
      </div>

      {/* Backdrop for Mobile Sidebar */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[45] backdrop-blur-sm transition-opacity duration-300 md:hidden"
          onClick={closeSidebar}
        ></div>
      )}

      {/* Backdrop for Right Sidebars */}
      {(isProfileSidebarOpen ||
        isReferSidebarOpen ||
        isQuickSelectSidebarOpen) && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[998] backdrop-blur-sm transition-opacity duration-300"
          onClick={closeAllSidebars}
        ></div>
      )}

      {/* Profile Sidebar */}
      <div
        className={`fixed top-0 right-0 w-80 h-full bg-white shadow-2xl z-[999] transform transition-transform duration-300 ${
          isProfileSidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-900 to-black text-white">
            <div className="flex justify-between items-start mb-4">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 rounded-full bg-white overflow-hidden border-white ">
                  {Sitelogo ? (
                    <img
                      src={Sitelogo}
                      alt="Company Logo"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-600 flex items-center justify-center text-white text-lg font-bold">
                      {GlobalData.company.companyName?.charAt(0) || "C"}
                    </div>
                  )}
                </div>
                <div>
                  <h2 className="text-sm font-bold">
                    {GlobalData.company.companyName}
                  </h2>
                </div>
              </div>
              <button
                onClick={closeAllSidebars}
                className="p-2 rounded-full hover:bg-gray-800 transition duration-200"
              >
                X
              </button>
            </div>
          </div>

          {/* My Account & Logout */}
          <div className="p-4 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <Link
                to="/auth/my-account"
                className="flex items-center space-x-2 text-gray-700 hover:text-black transition duration-200"
                onClick={closeAllSidebars}
              >
                <FcManager className="text-xl" />
                <span className="font-medium">My Account</span>
              </Link>

              <button
                onClick={logout}
                className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition duration-200"
              >
                <IoMdLogOut className="text-lg" />
                <span className="font-medium">Logout</span>
              </button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="flex-1 overflow-y-auto">
            <div className="p-4">
              <h3 className="flex items-center space-x-2 text-sm font-semibold text-gray-700 mb-4">
                <FcSupport className="text-lg" />
                <span>Need Assistance?</span>
              </h3>

              <div className="space-y-2">
                {[
                  {
                    q: "What is this platform?",
                    a: "This is a comprehensive business management platform designed to help you manage your business operations efficiently.",
                  },
                  {
                    q: "How does the Refer & Earn program work?",
                    a: "You can refer friends, colleagues, or clients. You'll earn rewards for every qualified signup and commission from their subscription payments.",
                  },
                  {
                    q: "Is there a limit to the number of referrals?",
                    a: "No, you can refer as many people as you like. The more referrals, the more rewards you can earn.",
                  },
                  {
                    q: "How do I get my referral link?",
                    a: "Your referral link is available in your account under the 'Refer & Earn' section. You can copy and share it anytime.",
                  },
                  {
                    q: "When will I receive my rewards?",
                    a: "Signup rewards are credited instantly after a qualified signup. Subscription commission credits are applied monthly.",
                  },
                ].map((faq, index) => (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-lg overflow-hidden"
                  >
                    <button
                      onClick={() =>
                        setOpenIndex(openIndex === index ? null : index)
                      }
                      className="flex justify-between items-center w-full p-3 text-left hover:bg-gray-50 transition duration-200"
                    >
                      <span className="text-sm font-medium text-gray-700">
                        {faq.q}
                      </span>
                      {openIndex === index ? (
                        <FcUpRight className="text-gray-500" />
                      ) : (
                        <FcDownRight className="text-gray-500" />
                      )}
                    </button>
                    {openIndex === index && (
                      <div className="p-3 bg-gray-50 border-t border-gray-200">
                        <p className="text-sm text-gray-600">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Contact Info */}
              <div className="mt-6 p-3 bg-gray-100 rounded-lg border border-gray-200">
                <div className="flex items-center space-x-2 text-sm">
                  <FcPhone />
                  <span className="font-semibold text-gray-800">
                    Talk to us:
                  </span>
                  <span className="text-gray-800">
                    {GlobalData.company.companyPhone}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* What's New */}
          <div className="p-4 border-t border-gray-200 bg-gradient-to-r from-gray-100 to-gray-200">
            <Link
              to="/updates"
              className="flex items-center space-x-2 text-gray-700 hover:text-black transition duration-200"
              onClick={closeAllSidebars}
            >
              <FcIdea className="text-lg" />
              <span className="font-semibold">What's New?</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Refer & Earn Sidebar */}
      <div
        className={`fixed top-0 right-0 w-80 h-full bg-white shadow-2xl z-[999] transform transition-transform duration-300 ${
          isReferSidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-800 to-black text-white">
            <div className="flex justify-between items-start">
              <div>
                <h2 className="text-xl font-bold">Refer & Earn</h2>
                <p className="text-gray-300 text-sm mt-1">
                  Share and earn rewards
                </p>
              </div>
              <button
                onClick={closeAllSidebars}
                className="p-2 hover:bg-gray-700 rounded-full transition duration-200"
              >
                X
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto">
            <div className="p-6">
              {/* Banner */}
              <div className="w-full h-48 rounded-xl overflow-hidden mb-6 bg-gradient-to-br from-gray-600 to-black flex items-center justify-center">
                <div className="text-white text-center">
                  <FcCollaboration className="text-4xl mx-auto mb-2" />
                  <h3 className="text-xl font-bold">Earn Together</h3>
                </div>
              </div>

              {/* Content */}
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    Know someone who would love our platform?
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Refer them today and earn{" "}
                    <span className="font-semibold text-black">$3</span> for
                    every qualified signup — plus{" "}
                    <span className="font-semibold text-black">20%</span> of
                    their subscription payment as wallet credits.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-gray-100 to-gray-200 p-4 rounded-lg border border-gray-300">
                  <h4 className="font-semibold text-gray-800 mb-3">
                    How it works:
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    {[
                      "Share your referral link with friends, colleagues, or clients",
                      "Earn $3 instantly for every qualified signup",
                      "Get 20% of their subscription payment as wallet credits",
                      "Your contact gets $100 in wallet credits for signing up",
                      "Refer as many people as you like — no limit!",
                    ].map((item, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <div className="w-5 h-5 bg-black text-white rounded-full flex items-center justify-center text-xs mt-0.5 flex-shrink-0">
                          {index + 1}
                        </div>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <p className="text-xs text-gray-500 text-center">
                  *Terms and Conditions apply
                </p>
              </div>
            </div>
          </div>

          {/* Footer Button */}
          <div className="p-6 border-t border-gray-200">
            <button
              onClick={() => {
                navigator.clipboard.writeText(
                  "https://mybusiness.com/referral"
                );
                alert("Link copied to clipboard!");
              }}
              className="w-full px-6 py-3 bg-black hover:bg-gray-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Copy Invite Link
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
